import { useState } from 'react';
import InitFilters from './constants/InitFiltering';

const useCustomHook = () => {
  const [loading, setLoading] = useState(true);
  const [filterParams, setFilterParams] = useState(null);
  const [voucherList, setVoucherList] = useState(null);
  const [callReq, setCallReq] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [, setGuildsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(false);
  const [filters, setFilters] = useState(InitFilters());

  return {
    filterParams,
    setFilterParams,
    loading,
    setLoading,
    size,
    setSize,
    page, setPage,
    setGuildsList,
    guildListLoading,
    setGuildListLoading,
    filters,
    page, setPage,
    setFilters,
    voucherList,
    setVoucherList,
    callReq, setCallReq
  };
};

export default useCustomHook;
